import styled from 'styled-components';

const DetailedSubMenuContainer = styled.div`
  .mega-menu-splitter {
    height: 1px;
    opacity: 0.5;
    border-top: 1px solid #b5c4cb;
    margin: 8px 52px;
  }

  .mega-menu--footer {
    background: #fbfbfb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    height: 60px;
  }

  .mega-menu--footer-item {
    flex: 1;
    height: 100%;

    a {
      display: table-cell;
      vertical-align: middle;
      line-height: 60px;
      width: 100%;
      height: 100%;
      color: black !important;
      font-size: 17px;
    }
  }

  .mega-menu--footer-item.see-all {
    a {
      padding: 0 20px 0 30px;

      &:hover {
        background: var(--blue-fourth);
      }
    }

    color: black;
    overflow: hidden;

    svg {
      margin-left: 13px;
    }
  }

  .mega-menu--footer-item.onboarding,
  .mega-menu--footer-item.comparison {
    overflow-y: clip;
  }

  .mega-menu--footer-item:last-child {
    padding: 30px 10px 30px 0px;
    background: #36363a;
  }

  .mega-menu--footer-item-content {
    font-size: 17px;
    display: flex;
    align-items: center;

    padding: 0px 20px;

    &:hover {
      background: var(--blue-fourth);
    }
  }

  .onboarding-content {
    position: relative;
    margin-left: -30px;
  }
  @media (min-width: 1241px) {
    .onboarding-content:after {
      content: '';
      position: absolute;
      width: 32px;
      height: 0px;
      left: -23px;
      top: 30px;

      border: 1px solid #cfd8dc;
      transform: rotate(90deg);
    }
  }

  .comparison-content {
    margin: 0 30px 0 -30px;
  }

  @media (min-width: 1241px) {
    background: var(--white-color);
    border: 1px solid #e9eff2;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    position: absolute;
    padding: 0 0 0 30px;
    transition: opacity 0.1s;
    z-index: 2147483647 !important;
    max-width: 1195px;
    width: 100%;
    left: 10%;
    visibility: hidden;
    opacity: 0;
    margin-top: -20px;
    transition: all 0.25s ease-out;
    pointer-events: none;
    display: flex;
  }

  @media (max-width: 1240px) {
    visibility: hidden;
    opacity: 0;
    transition: max-height 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    margin-top: 0 !important;
    flex-direction: column;

    .mega-menu--footer {
      background: white;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      margin: 20px 0px 0px 20px;
      left: 0px;
      bottom: 0px;
      height: max-content;
    }

    .mega-menu--footer-item.spacer,
    .mega-menu--footer-item:last-child {
      display: none;
    }

    .mega-menu--footer-item.see-all {
      display: block;
      width: max-content;
      padding: 0 10px;
    }

    .mega-menu--footer-item.spacer,
    .mega-menu--footer-item:last-child {
      display: none;
    }

    .mega-menu--footer-item.see-all,
    .mega-menu--footer-item.onboarding {
      padding: 0;

      a {
        padding: 0;

        &:hover {
          background: none;
          cursor: pointer;
          color: var(--neutral-text-color) !important;
        }
      }
    }

    .mega-menu--footer-item-content {
      display: flex;
      flex-direction: row-reverse;
      width: max-content;
      padding: 0;
      margin: 0;

      &:hover {
        background: none;
        cursor: pointer;
        color: var(--neutral-text-color) !important;
      }

      svg {
        margin-left: 7px;
        height: 12px;
      }
    }

    .sub-mega-menu {
      padding: 0px 40px 20px 30px;

      &.sub-mega-menu-footer {
        padding: 20px 40px 20px 30px;
      }

      .sub-mega-menu--title {
        font-size: 14px;
      }

      .sub-mega-menu--content {
        padding: 10px 0 0;
      }

      .sub-mega-menu--content .mega-menu-item > a .mega-menu-item--content .mega-menu-item--title {
        font-size: 16px;
      }

      .ant-row {
        margin: -4px !important;
      }
    }

    .mega-menu-splitter {
      margin: 38px 28px;
    }
  }

  @media (max-width: 680px) {
    .sub-mega-menu {
      &.sub-mega-menu-footer {
        .sub-mega-menu--content .mega-menu-item .mega-menu-item--content .mega-menu-item--title {
          line-height: 28px;
        }
      }
    }

    .mega-menu-splitter {
      margin: 38px 20px;
    }

    .ant-row {
      margin: -4px !important;

      .ant-col {
        padding: 4px !important;
      }
    }
  }
`;

export { DetailedSubMenuContainer };
